import { ChevronDown, ChevronRight, ExternalLink, Award, Zap } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react'

const NavbarMain = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const menuRef = useRef(null);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const toggleProductsDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsProductsOpen((prev) => !prev);
  };

  const handleToggle = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fixed smooth scroll function
  const handleAnchorClick = (e, sectionId) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);

    console.log("=== CLICKED ON MENU ITEM ===");
    console.log("Target section ID:", sectionId);

    // Find the element by ID
    const element = document.getElementById(sectionId);

    if (element) {
      console.log("Element found! Scrolling to:", sectionId);
      const offset = 80; // Offset for fixed header
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else {
      console.error(`Element with id "${sectionId}" NOT found on the page!`);
      // Try to find by class as fallback
      const fallbackElement = document.querySelector(`.${sectionId}`);
      if (fallbackElement) {
        console.log("Found by class instead:", sectionId);
        const offset = 80;
        const elementPosition = fallbackElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  // Handle external link for Startup India
  const handleStartupClick = () => {
    window.open('https://www.startupindia.gov.in/content/sih/en/profile.Startup.69a92fcce4b0b7e5b729f0f8.html', '_blank', 'noopener noreferrer');
  };

  return (
    <div>
      <>
        <div className={`overlay ${isOpen ? "open" : ""}`} style={{ zIndex: "9999" }}></div>

        {/* ===== MOBILE OFF-CANVAS NAV ===== */}
        <nav
          id="hc-nav-1"
          className={`hc-offcanvas-nav hc-nav-1 nav-levels-overlap nav-position-left disable-body nav-close-button-empty ${isOpen ? "open" : ""}`}
          style={{ zIndex: "99999" }}
          aria-hidden={!isOpen}
          aria-labelledby="hc-nav-1-nav-title"
        >
          <div className="nav-container" ref={menuRef}>
            <div className="nav-wrapper nav-wrapper-0" data-level={0} data-index={0}>
              <div className="nav-content">
                <h2 id="hc-nav-1-nav-title" className="nav-title">Mount Saffron</h2>
                <div className="nav-close">
                  <a href="#" className="nav-close-button" role="menuitem" tabIndex={0} onClick={handleToggle} aria-label="Close Menu">
                    <span />
                  </a>
                </div>

                <ul role="menu" aria-level={1}>
                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#home" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'home')} role="menuitem">Home</a>
                    </div>
                  </li>

                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#about" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'about')} role="menuitem">About Us</a>
                    </div>
                  </li>

                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#services" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'service')} role="menuitem">Services</a>
                    </div>
                  </li>

                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#blog" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'blog')} role="menuitem">Approach</a>
                    </div>
                  </li>

                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#work" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'work')} role="menuitem">Our Projects</a>
                    </div>
                  </li>

                  {/* Our Products dropdown - ONLY DROPDOWN */}
                  <div className="megamenu-item">
                    <a href="#" onClick={toggleProductsDropdown} className="d-flex justify-content-between align-items-center menu-title nav-item-link">
                      <span>Our Products</span>
                      {isProductsOpen ? <ChevronDown className="ms-2" /> : <ChevronRight className="ms-2" />}
                    </a>
                    <ul className={`submenu list-unstyled ps-3 ${isProductsOpen ? "show" : "hide"}`}>
                      <li><a href="https://violetsync.com/" className="dropdown-item nav-item-link" onClick={handleToggle} target="_blank">VioletSync</a></li>
                      <li><a href="https://www.softapproachit.com/" className="dropdown-item nav-item-link" onClick={handleToggle} target="_blank">SoftApproachIT</a></li>
                      <li><a href="https://www.codejido.com/" className="dropdown-item nav-item-link" onClick={handleToggle} target="_blank">CodeJido</a></li>
                    </ul>
                  </div>

                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#why" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'why')} role="menuitem">Why Choose Us</a>
                    </div>
                  </li>

                  <li className="nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#contact" className="menu-links nav-item-link" tabIndex={0} onClick={(e) => handleAnchorClick(e, 'contact')} role="menuitem">Contact Us</a>
                    </div>
                  </li>
                </ul>

                {/* Bottom social icons */}
                <ul role="menu" aria-level={1} className="bottom-nav">
                  <li className="nav-item ree-hc">
                    <div className="nav-item-wrapper">
                      <a href="tel:9024821468" rel="noreferrer" target="_blank" className="nav-item-link" tabIndex={0} role="menuitem">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25.625 25.625" style={{ enableBackground: "new 0 0 25.625 25.625" }} xmlSpace="preserve">
                          <g><path d="M22.079,17.835c-1.548-1.324-3.119-2.126-4.648-0.804l-0.913,0.799c-0.668,0.58-1.91,3.29-6.712-2.234C5.005,10.079,7.862,9.22,8.531,8.645l0.918-0.8c1.521-1.325,0.947-2.993-0.15-4.71l-0.662-1.04C7.535,0.382,6.335-0.743,4.81,0.58L3.986,1.3C3.312,1.791,1.428,3.387,0.971,6.419c-0.55,3.638,1.185,7.804,5.16,12.375c3.97,4.573,7.857,6.87,11.539,6.83c3.06-0.033,4.908-1.675,5.486-2.272l0.827-0.721c1.521-1.322,0.576-2.668-0.973-3.995L22.079,17.835z" /></g>
                        </svg>
                      </a>
                    </div>
                  </li>
                  <li className="nav-item ree-hc">
                    <div className="nav-item-wrapper">
                      <a href="mailto:info@mountsaffronit.com" target="_blank" className="nav-item-link" tabIndex={0} role="menuitem">
                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" /><path d="M0 0h24v24H0z" fill="none" />
                        </svg>
                      </a>
                    </div>
                  </li>
                  <li className="nav-item ree-hc">
                    <div className="nav-item-wrapper">
                      <a href="https://wa.me/919024821468" rel="noreferrer" target="_blank" className="nav-item-link" tabIndex={0} role="menuitem">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlSpace="preserve">
                          <g><path d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z" /></g>
                        </svg>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>

        {/* ===== DESKTOP HEADER ===== */}
        <header className={`ree-header fixed-top ${isSticky ? "sticky" : ""}`} style={{ top: '0' }}>
          <div className="container-fluid m-p-l-r-0">
            <div className="menu-header">

              <div className="menu-logo">
                <div className="dskt-logo">
                  <a className="nav-brand" href="/">
                    <img src="images/logom.png" alt="Mount Saffron Logo" width={240} className="ree-logo" />
                  </a>
                </div>
              </div>

              <div className="ree-nav" role="navigation">
                <ul className="nav-list">
                  <li>
                    <a href="#home" className="menu-links" onClick={(e) => handleAnchorClick(e, 'home')}>Home</a>
                  </li>

                  <li>
                    <a href="#about" className="menu-links" onClick={(e) => handleAnchorClick(e, 'about')}>About Us</a>
                  </li>

                  <li>
                    <a href="#service" className="menu-links" onClick={(e) => handleAnchorClick(e, 'service')}>Services</a>
                  </li>

                  <li>
                    <a href="#blog" className="menu-links" onClick={(e) => handleAnchorClick(e, 'blog')}>Approach</a>
                  </li>

                  <li>
                    <a href="#work" className="menu-links" onClick={(e) => handleAnchorClick(e, 'work')}>Our Projects</a>
                  </li>

                  {/* Our Products dropdown - Desktop */}
                  <li className="megamenu mega-small nav-item">
                    <div className="nav-item-wrapper">
                      <a href="#product" className="menu-links nav-item-link" role="menuitem">Our Products</a>
                      <div className="menu-dropdown">
                        <div className="menu-block-set">
                          <a className="dropdown-item" href="https://violetsync.com/" target="_blank">VioletSync</a>
                          <a className="dropdown-item" href="https://www.softapproachit.com/" target="_blank">SoftApproachIT</a>
                          <a className="dropdown-item" href="https://www.codejido.com/" target="_blank">CodeJido</a>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <a href="#why" className="menu-links" onClick={(e) => { e.preventDefault(); document.querySelector('.home-app-block')?.scrollIntoView({ behavior: 'smooth' }); }}>Why Choose Us</a>
                  </li>

                  <li>
                    <a href="#contact" className="menu-links" onClick={(e) => handleAnchorClick(e, 'contact')}>Contact Us</a>
                  </li>
                </ul>
              </div>

              {/* Mobile toggle */}
              <div className="mobile-menu2">
                <ul className="mob-nav2">
                  <li
                    className={`toggle hc-nav-trigger hc-nav-1 ${isOpen ? "toggle-open" : ""}`}
                    role="button"
                    aria-label={isOpen ? "Close Menu" : "Open Menu"}
                    aria-controls="hc-nav-1"
                    aria-expanded={isOpen ? "true" : "false"}
                    onClick={handleToggle}
                  >
                    <span></span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </header>

        {/* ===== STICKY STARTUP INDIA CARD ===== */}
        <div
          className="startup-india-card"
          onClick={handleStartupClick}
          style={{
            position: 'fixed',
            right: '20px',
            top: '90px',
            zIndex: 9998,
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.02)',
            padding: '12px 18px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(255,107,53,0.2)',
            backdropFilter: 'blur(8px)',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)',
            maxWidth: '260px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0,0,0,0.15), 0 10px 10px -5px rgba(0,0,0,0.05)';
            e.currentTarget.style.borderColor = '#ff6b35';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.02)';
            e.currentTarget.style.borderColor = 'rgba(255,107,53,0.2)';
          }}
        >
          {/* Icon */}
          <div style={{
            //  backgroundColor: '#ff6b35',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white'
          }}>
            <img
              src="images/icons/services/certificate.gif"
              alt="certificate"
              className="step-img"
            />
          </div>

          {/* Content */}
          <div style={{ flex: 1 }}>
            <div style={{
              fontSize: '12px',
              fontWeight: 600,
              letterSpacing: '0.5px',
              color: '#ff6b35',
              marginBottom: '4px'
            }}>
              Govt. Recognized
            </div>
            <div style={{
              fontSize: '15px',
              fontWeight: 700,
              color: '#1a1a2e',
              marginBottom: '2px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              Startup India
            </div>
            <div style={{
              fontSize: '16px',
              fontWeight: 600
            }}>
              DIPP248035
            </div>
          </div>

          {/* Optional badge */}
          <div style={{
            position: 'absolute',
            top: '-8px',
            right: '-8px',
            backgroundColor: '#10b981',
            color: 'white',
            fontSize: '8px',
            fontWeight: 'bold',
            padding: '2px 6px',
            borderRadius: '20px',
            letterSpacing: '0.5px'
          }}>
            VERIFIED
          </div>
        </div>

        {/* Responsive CSS for mobile */}
        <style>
          {`
            @media (max-width: 768px) {
              .startup-india-card {
                top: 70px !important;
                right: 12px !important;
                padding: 8px 12px !important;
                max-width: 220px !important;
              }
              .startup-india-card > div:first-child {
                padding: 6px !important;
              }
              .startup-india-card > div:first-child svg {
                width: 18px !important;
                height: 18px !important;
              }
              .startup-india-card > div:nth-child(2) > div:first-child {
                font-size: 10px !important;
              }
              .startup-india-card > div:nth-child(2) > div:nth-child(2) {
                font-size: 13px !important;
              }
              .startup-india-card > div:nth-child(2) > div:last-child {
                font-size: 9px !important;
              }
            }
          `}
        </style>
      </>
    </div>
  );
};

export default NavbarMain;